export function capitalize(value: string): string {
  return value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : value;
}

export function decodeGuid(encoded: string): Uint8Array {
  encoded = encoded.replace(/_/g, "/").replace(/-/g, "+");
  const binaryString = atob(encoded + "==");
  const buffer = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    buffer[i] = binaryString.charCodeAt(i);
  }
  return buffer; // 16-byte array matching .NET's Guid byte layout
}

// Converts a .NET Guid byte layout (first 3 groups little-endian, last 2 big-endian) to its string form
export function decodeGuidToString(encoded: string): string {
  const b = decodeGuid(encoded);
  const hex = (i: number) => b[i].toString(16).padStart(2, "0");

  const data1 = [3, 2, 1, 0].map(hex).join(""); // little-endian
  const data2 = [5, 4].map(hex).join(""); // little-endian
  const data3 = [7, 6].map(hex).join(""); // little-endian
  const data4a = [8, 9].map(hex).join(""); // big-endian
  const data4b = [10, 11, 12, 13, 14, 15].map(hex).join(""); // big-endian

  return `${data1}-${data2}-${data3}-${data4a}-${data4b}`;
}

export function formatStoryCountdown(milliseconds: number): string {
  const totalSeconds = Math.ceil(milliseconds / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const parts = [
    days > 0 ? `${days}d` : null,
    hours > 0 || days > 0 ? `${hours}h` : null,
    `${minutes}m`,
    `${seconds}s`,
  ].filter((part): part is string => part !== null);

  return parts.join(" ");
}
